import React from "react";
import {
    Button,
    convertInputFormToObject,
    InputForm, inputStyles,
    useInputForm
} from "../../../../Components/Inputs";
import {clearInputFormFields} from "../../../../Components/Inputs/inputUtility";
import {GridCell, gridConstants, GridContainer} from "../../../../Components/Grid";
import {SearchableSingleSelectField} from "../../../../Components/Inputs/SearchableSingleSelectField";

import type {ListItem} from "../../../../Utilities/Types/listUtilities";

interface LoanSearchFormViewProps {
    handleSetLoanSearchCriteria: (criteria: Record<string, any>) => void;
    isLoading: boolean;
    loanSearchCriteria: Record<string, any>;
    patrons?: ListItem[];
    shippingLocations?: ListItem[];
    students?: ListItem[];
}

export const LoanSearchFormView = ({
                                       handleSetLoanSearchCriteria,
                                       isLoading,
                                       loanSearchCriteria,
                                       patrons=[],
                                       shippingLocations=[],
                                       students=[]
                                   }: LoanSearchFormViewProps) => {

    const searchForm = useInputForm(loanSearchCriteria);

    const handleClearClick = () => {
        clearInputFormFields(searchForm);
        const updatedLoanSearchCriteria = {...loanSearchCriteria};
        updatedLoanSearchCriteria.ClearOrderSearch();
    };

    const handleSearchClick = () => {
        let criteria = convertInputFormToObject(searchForm);
        const updatedLoanSearchCriteria = {...loanSearchCriteria};
        updatedLoanSearchCriteria.Search(criteria);
        handleSetLoanSearchCriteria(updatedLoanSearchCriteria);
    };

    const inputSharedSettings = {
        medium_columns: gridConstants.column.FOUR,
    };

    return <>
        <InputForm name={"loanSearch"} hasPaddingY>

            <SearchableSingleSelectField
                {...searchForm.patronId}
                {...inputSharedSettings}
                includeDefaultOption
                label={'Patron'}
                options={patrons}
            />

            <SearchableSingleSelectField
                {...searchForm.shippingLocationId}
                {...inputSharedSettings}
                includeDefaultOption
                label={'Shipping Locations'}
                options={shippingLocations}
            />

            <SearchableSingleSelectField
                {...searchForm.studentId}
                {...inputSharedSettings}
                includeDefaultOption
                label={'Student'}
                options={students}
            />

            <GridCell>
                <GridContainer hasPaddingX isFlush isReverseOrder>

                    <GridCell medium_columns={gridConstants.column.FOUR}>
                        <Button
                            buttonType={inputStyles.button.types.SEARCH}
                            disabled={isLoading}
                            label="Search"
                            name="btnSearchLoan"
                            onClick={handleSearchClick}
                            isPrimary
                        />
                    </GridCell>

                    <GridCell medium_columns={gridConstants.column.FOUR}>
                        <Button
                            buttonType={inputStyles.button.types.CLEAR}
                            disabled={isLoading}
                            name="btnClearLoanSearch"
                            onClick={handleClearClick}
                            label="Clear"
                        />
                    </GridCell>

                </GridContainer>
            </GridCell>

        </InputForm>
    </>;
};

